import contentfulGql from 'js/lib/contentfulGql';

export const articlesDirectoryBySubfolderContentQuery = contentfulGql`#graphql
query ArticlesDirectoryBySubfolderContent($countryCode: String!, $languageCode: String!, $limit: Int, $skip: Int, $isPreview: Boolean){
  articleCollection(
    preview: $isPreview, 
    where: {
      AND:
        [
          { localizedCountryCode: $countryCode }, 
          { localizedLanguageCode: $languageCode }
        ]
    }, 
    order: title_ASC, 
    limit: $limit, 
    skip: $skip) {
    items {
      title,
      slug,
    },
    total
  }
}
`;
